import qs from 'query-string';
import { apiConfig } from '../api-config';

export interface GetOneByCodeVoucherParams {
  tokenKey: string;
  codeVoucher: string;
}

export const getOneByCodeVoucher = async (params: GetOneByCodeVoucherParams) => {
  const query = qs.stringify(params);
  return apiConfig
    .get(`api/Voucher/get-by-codeVoucher?${query}`)
    .then((response) => response.data)
    .catch((err) => ({ hasErrors: true, error: err.message }));
};
